import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles/styles.module.scss';
import formStyles from '../../styles/styles.module.scss';
import baseStyles from '../../../../styles/baseStyles.module.scss';

import PlanTypeCardCollection from '../PlanTypeCardCollection';
import SubmitButton from '../../buttons/SubmitButton';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderPlanTypes() {
    return (
      <PlanTypeCardCollection
        planTypes={this.props.planTypes}
        handler={this.props.handleClick}
        activePlanType={this.props.activePlanType}
        currencyCode={this.props.currencyCode}
        verifiedCoupon={this.props.verifiedCoupon}
        isCouponApplied={this.props.isCouponApplied}
      />
    );
  }

  render() {
    return (
      <div className={styles.planTypeContainer}>
        <div className={(baseStyles.container, formStyles.container)}>
          <div className={formStyles.head}>{this.props.text.headText}</div>
          <div className={baseStyles.section}>
            <div className={(baseStyles.row, formStyles.group)}>
              <div className={(baseStyles.row, formStyles.buttonGroup)} orientation="vertical">
                {this.renderPlanTypes()}
              </div>
            </div>
            <div className={baseStyles.row}>
              <SubmitButton text={this.props.text.submitText} handler={this.props.handleSubmit} variant="submit" />
            </div>
          </div>
          <div className={formStyles.foot}>{this.props.text.footText}</div>
        </div>
      </div>
    );
  }
}

Form.defaultProps = {
  handleSubmit: () => {},
  handleClick: () => {},
  activePlanType: null,
  currencyCode: null,
  verifiedCoupon: {},
  isCouponApplied: false,
  text: {
    submitText: 'Get started',
    activePlanType: 0,
    headText: '',
    footText: ''
  }
};

Form.propTypes = {
  handleSubmit: PropTypes.func,
  handleClick: PropTypes.func,
  activePlanType: PropTypes.number,
  currencyCode: PropTypes.string,
  verifiedCoupon: PropTypes.shape({
    code: PropTypes.string,
    discountPercentage: PropTypes.number,
    discountedPricePerYear: PropTypes.string,
    id: PropTypes.number,
    metaData: PropTypes.object,
    originalPricePerYear: PropTypes.string,
    type: PropTypes.string
  }),
  isCouponApplied: PropTypes.bool,
  text: PropTypes.shape({
    headText: PropTypes.string,
    submitText: PropTypes.string,
    footText: PropTypes.string
  }),
  planTypes: PropTypes.arrayOf(
    PropTypes.shape({
      handler: PropTypes.func,
      label: PropTypes.string,
      showDiscount: PropTypes.bool,
      details: PropTypes.string,
      active: PropTypes.bool
    })
  ).isRequired
};

export default Form;
